import { render, staticRenderFns } from "./ResidentialDetachedResidence.vue?vue&type=template&id=01ab9d7a&scoped=true&"
import script from "./ResidentialDetachedResidence.vue?vue&type=script&lang=ts&"
export * from "./ResidentialDetachedResidence.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialDetachedResidence.vue?vue&type=style&index=0&id=01ab9d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab9d7a",
  null
  
)

export default component.exports